import { render } from "./MemberLayout.vue?vue&type=template&id=61e93ef6"
import script from "./MemberLayout.vue?vue&type=script&lang=js"
export * from "./MemberLayout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\acer1\\Desktop\\TTT-Member\\Partner\\GOODLUCK711\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__